import { WithDisposable } from '@blocksuite/affine/global/lit';
import { ShadowlessElement } from '@blocksuite/affine/std';
import type { TestAffineEditorContainer } from '@blocksuite/integration-test';
import { effect } from '@preact/signals-core';
import { css, html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

@customElement('custom-frame-panel')
export class CustomFramePanel extends WithDisposable(ShadowlessElement) {
  static override styles = css`
    .custom-frame-container {
      position: fixed;
      top: 0;
      right: 0;
      border: 1px solid var(--affine-border-color, #e3e2e4);
      background-color: var(--affine-background-primary-color, #ffffff);
      height: 100vh;
      width: 320px;
      box-sizing: border-box;
      z-index: 1000;
      box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
      display: flex;
      flex-direction: column;
      color: var(--affine-text-primary-color, #000000);
      font-family: sans-serif;
    }
    .panel-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid var(--affine-border-color, #e3e2e4);
      font-weight: 600;
      font-size: 16px;
    }
    .panel-close {
      cursor: pointer;
      font-size: 18px;
      opacity: 0.6;
    }
    .panel-close:hover {
      opacity: 1;
    }
    .panel-content {
      flex: 1;
      overflow-y: auto;
    }
  `;

  private _renderPanel() {
    return html`<affine-frame-panel
      .host=${this.editor.std.host}
    ></affine-frame-panel>`;
  }

  override connectedCallback(): void {
    super.connectedCallback();

    this.disposables.add(
      effect(() => {
        const std = this.editor.std;
        if (std) {
          this.editor.updateComplete
            .then(() => this.requestUpdate())
            .catch(console.error);
        }
      })
    );
  }

  override render() {
    return html`
      ${this._show
        ? html`
            <div class="custom-frame-container">
              <div class="panel-header">
                <span>Frame Panel</span>
                <span class="panel-close" @click=${() => this._show = false}>✕</span>
              </div>
              <div class="panel-content">
                ${this._renderPanel()}
              </div>
            </div>
          `
        : nothing}
    `;
  }

  toggleDisplay() {
    this._show = !this._show;
  }

  @state()
  private accessor _show = false;

  @property({ attribute: false })
  accessor editor!: TestAffineEditorContainer;
}

declare global {
  interface HTMLElementTagNameMap {
    'custom-frame-panel': CustomFramePanel;
  }
}
